export default __webpack_public_path__ + "static/media/36.69aba6e3.jpeg";